import { useCallback, useMemo } from "react";
import { useReactivateSubscriptionMutation } from "src/api/services/patientSubscriptionApi";
import BasicModal from "../BasicModal";
import { useTranslation } from "react-i18next";

interface Props {
  subscriptionId: number | undefined;
  open: boolean;
  onClose: (o: boolean) => void;
}

const ReactivationModal = ({ subscriptionId, open, onClose }: Props) => {
  const [reactivate] = useReactivateSubscriptionMutation();
  const { t } = useTranslation();

  const modalTitle = useMemo(
    () => t(`task-modal.reactivate_membership.title`),
    [t]
  );

  const modalText = useMemo(
    () => t(`task-modal.reactivate_membership.text`),
    [t]
  );

  const modalButton = useMemo(
    () => t(`task-modal.reactivate_membership.buttonText`),
    [t]
  );

  const handleReactivation = useCallback(async () => {
    if (subscriptionId == null) return null;

    try {
      await reactivate(subscriptionId);
    } catch (err) {
      console.error(
        "Oops, looks like there an issue trying to reactivate your membership, please message our team.",
        err
      );
    }
  }, [reactivate, subscriptionId]);

  return (
    <BasicModal
      buttonText={modalButton}
      text={modalText}
      title={modalTitle}
      handleClick={handleReactivation}
      open={open}
      onClose={onClose}
    />
  );
};

export default ReactivationModal;
